import { INBOX_TYPES } from 'shared/mixins/inboxMixin';
import {
  getApiChannelKind,
  API_CHANNEL_ICONS,
  API_CHANNEL_KINDS,
} from './apiChannel';

export const getInboxSource = (type, phoneNumber, inbox) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return inbox.website_url || '';

    case INBOX_TYPES.TWILIO:
    case INBOX_TYPES.WHATSAPP:
      return phoneNumber || '';

    case INBOX_TYPES.EMAIL:
      return inbox.email || '';

    default:
      return '';
  }
};
export const getReadableInboxByType = (type, phoneNumber) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'livechat';

    case INBOX_TYPES.FB:
      return 'facebook';

    case INBOX_TYPES.TWITTER:
      return 'twitter';

    case INBOX_TYPES.TWILIO:
      return phoneNumber?.startsWith('whatsapp') ? 'whatsapp' : 'sms';

    case INBOX_TYPES.WHATSAPP:
      return 'whatsapp';

    case INBOX_TYPES.API:
      return 'api';

    case INBOX_TYPES.EMAIL:
      return 'email';

    case INBOX_TYPES.TELEGRAM:
      return 'telegram';

    case INBOX_TYPES.LINE:
      return 'line';

    default:
      return 'chat';
  }
};

export const getInboxClassByType = (type, phoneNumber, webhookUrl) => {
  switch (type) {
    case INBOX_TYPES.WEB:
      return 'globe-desktop';

    case INBOX_TYPES.FB:
      return 'brand-facebook';

    case INBOX_TYPES.TWITTER:
      return 'brand-twitter';

    case INBOX_TYPES.TWILIO:
      return phoneNumber?.startsWith('whatsapp')
        ? 'brand-whatsapp'
        : 'brand-sms';

    case INBOX_TYPES.WHATSAPP:
      return 'brand-whatsapp';

    case INBOX_TYPES.API:
      return API_CHANNEL_ICONS[getApiChannelKind(webhookUrl)] || 'cloud';

    case INBOX_TYPES.EMAIL:
      return 'mail';

    case INBOX_TYPES.TELEGRAM:
      return 'brand-telegram';

    case INBOX_TYPES.LINE:
      return 'brand-line';

    default:
      return 'chat';
  }
};

export const getInboxWarningIconClass = (type, reauthorizationRequired) => {
  const allowedInboxTypes = [INBOX_TYPES.FB, INBOX_TYPES.EMAIL];
  if (allowedInboxTypes.includes(type) && reauthorizationRequired) {
    return 'warning';
  }
  return '';
};

// Color de marca para el ícono de la bandeja (sidebar, nombre de bandeja).
// Hex y no clases de Tailwind: tailwind.config.js no escanea los .js, así que
// una clase definida acá nunca se generaría.
const INBOX_ICON_COLORS = {
  'brand-whatsapp': '#25D366',
  'brand-instagram': '#E4405F',
  'brand-facebook': '#0866FF',
  'brand-telegram': '#26A5E4',
  'brand-line': '#06C755',
};

export const getInboxIconColor = icon => INBOX_ICON_COLORS[icon] || null;

// WhatsApp QR y WhatsApp API usan el mismo ícono: QR va en ámbar para
// distinguirlas de un vistazo (el verde queda para la API oficial). Ámbar y
// no azul (Telegram), rosa (Instagram) ni violeta (la IA).
export const WHATSAPP_QR_ICON_COLOR = '#F5A524';

export const getInboxBrandColor = (type, phoneNumber, webhookUrl) => {
  if (
    type === INBOX_TYPES.API &&
    getApiChannelKind(webhookUrl) === API_CHANNEL_KINDS.WHATSAPP_QR
  ) {
    return WHATSAPP_QR_ICON_COLOR;
  }
  return getInboxIconColor(getInboxClassByType(type, phoneNumber, webhookUrl));
};
